export default class CustomAnimation {
    constructor(elm, args) {

        if (isInViewport(elm)) {
            elm.classList.add('section-animation');
        }

        window.addEventListener('scroll', e => {

            if (isInViewport(elm)) {
                elm.classList.add('section-animation');
            }
        });

    function isInViewport(element) {
            const rect = element.getBoundingClientRect();
            return (
                rect.top >= 0 &&
                rect.left >= 0 &&
                rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
                rect.right <= (window.innerWidth || document.documentElement.clientWidth)
            );
        }
    }
}
